// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Header-module--wrapper--2d1Pt","container":"Header-module--container--1n00k","logo":"Header-module--logo--10MlI","link":"Header-module--link--2Oeqp"};